import logo from './logo.svg';
import './App.css';
import Benefits from './views/Benefits';
import Contact from './views/Contact';
import Home from './views/Home';
import HowWeWorks from './views/HowWeWorks';
import Services from './views/Services';
import NavBar from './Components/NavBar';

function App() {
  return (
    <div className="App">
      <NavBar/>
      <Home/>
      <Services/>
      {/* <HowWeWorks/>
      <Benefits/> */}
      <Contact/>                   
    </div>
  );
}

export default App;
